import React from "react";
import { TextField } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { useMergeContactModalStore } from "../../store/useMergeContactModalStore";
import { FIELD_MAP } from "../../constants/MergeContactFormModal.constant";
import { useMergeContact } from "../../utils/hooks/useMergeContact";

export const TextSuggestionField = ({ fieldKey }) => {
  const mergedContactDetailsForm = useMergeContactModalStore(
    (state) => state.mergedContactDetailsForm
  );
  const setMergedContactDetails = useMergeContactModalStore(
    (state) => state.setMergedContactDetails
  );
  const { fetchOptions } = useMergeContact();

  return (
    <Autocomplete
      freeSolo
      options={fetchOptions(fieldKey)}
      value={mergedContactDetailsForm?.[fieldKey]}
      inputValue={mergedContactDetailsForm?.[fieldKey]}
      forcePopupIcon={true}
      popupIcon={<ExpandMoreIcon />}
      classes={{
        endAdornment: "!tw-right-1.5",
      }}
      onChange={(event, newValue) => {
        setMergedContactDetails(fieldKey, newValue);
      }}
      onInputChange={(event, newInputValue) => {
        setMergedContactDetails(fieldKey, newInputValue);
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder={FIELD_MAP[fieldKey]?.placeholder}
          variant="outlined"
          InputProps={{
            ...params.InputProps,
            className: "tw-h-[40px] tw-flex tw-items-center tw-pr-8",
            endAdornment: (
              <div className="tw-flex tw-items-center tw-mr-2">
                {params.InputProps.endAdornment}
              </div>
            ),
          }}
          inputProps={{
            ...params.inputProps,
            className: "tw-h-[40px] tw-px-3 tw-py-0 tw-box-border",
          }}
        />
      )}
    />
  );
};
